function createOverlay(image) {
  const overlay = document.createElement('div');
  const imageSource = image.currentSrc || image.src;

  overlay.className = 'image-magnify-full-size';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${imageSource}')`;
  overlay.style.backgroundRepeat = 'no-repeat';
  overlay.style.backgroundSize = `${image.clientWidth * 2}px ${image.clientHeight * 2}px`;

  return overlay;
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const imageBounds = image.getBoundingClientRect();
  const xPosition = event.clientX - imageBounds.left;
  const yPosition = event.clientY - imageBounds.top;
  const xPercent = `${(xPosition / imageBounds.width) * 100}%`;
  const yPercent = `${(yPosition / imageBounds.height) * 100}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${imageBounds.width * zoomRatio}px ${imageBounds.height * zoomRatio}px`;
}

function enableZoomOnHover(zoomRatio) {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    if (image.dataset.matchyZoomReady === 'true') return;
    image.dataset.matchyZoomReady = 'true';

    const frame = image.closest('.product__media');
    if (!frame) return;

    let overlay = null;

    image.addEventListener('mouseenter', (event) => {
      overlay = createOverlay(image);
      frame.appendChild(overlay);
      moveWithHover(image, overlay, event, zoomRatio);
    });

    image.addEventListener('mousemove', (event) => {
      if (!overlay) return;
      moveWithHover(image, overlay, event, zoomRatio);
    });

    image.addEventListener('mouseleave', () => {
      overlay?.remove();
      overlay = null;
    });
  });
}

enableZoomOnHover(2);
